import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IDialogState {
  currentModal?: string;
  context?: unknown;
}

interface IRootState {
  dialog: IDialogState;
}

const initialState: IDialogState = {};

const dialogSlicePrivate = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog: (state, action: PayloadAction<IDialogState>) => {
      state.currentModal = action.payload.currentModal;
      state.context = action.payload.context;
    },
    closeDialog: state => {
      state.currentModal = undefined;
      state.context = undefined;
    },
  },
});

export const dialogSlice = {
  name: dialogSlicePrivate.name,
  reducer: dialogSlicePrivate.reducer,
};

export const selectDialogState = (state: IRootState) => state.dialog;

export const { closeDialog, openDialog } = dialogSlicePrivate.actions;
